'use strict';

var React = require('react');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');
var mouseHelper = require('../../helper/mouseHelper');

/**
 * Slider
 * 滑块
 */
var Slider = React.createClass({
  getInitialState: function () {
    return {
      progress: styleHelper.getInt(this.props, propConst.PROGRESS)
    };
  },
  render: function () {
    var progress = this.state.progress;
    var value = this.props.w * progress / 100;
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var ch = this.props.h;
    var bg = styleHelper.getBackgroundColor(this.props);

    var trackRightColor = this.props.borderColor;
    if (trackRightColor === 'rgba(0,0,0,0)') {
      trackRightColor = 'rgba(102,102,102,1)';
    }
    return (
      <div ref="slider" className="component-Slider" onClick={this.onTrackClick}>
        <span className="track-left" style={{
          top: h * 0.5 - 1,
          width: (progress === 100) ? (w - ch / 2) : value,
          backgroundColor: bg
        }}/>
        <span className="track-right" style={{
          left: (progress === 0) ? (ch / 2) : value,
          top: h * 0.5 - 1,
          width: (progress === 100) ? 0 : (progress === 0 ? (w - ch / 2) : (w - value)),
          background: trackRightColor
        }}/>
        <span className="slider"
              onMouseDown={this.onDrag}
              onTouchStart={this.onDrag}
              style={{
                left: Math.max(0, Math.min(value - ch / 2, w - ch)),
                top: (h - ch) / 2,
                width: ch,
                height: ch
              }}>
          <span className="slider-outer" style={{backgroundColor: bg}}/>
          <spane className="slider-inner" style={{
            left: (ch - 10) / 2,
            top: (ch - 10) / 2,
            backgroundColor: bg
          }}/>
        </span>
      </div>
    );
  },
  onDrag: function (e) {
    var width = parseInt(this.props.w, 10);
    var self = this;
    var progress = this.state.progress;
    var unit = width / 100;
    mouseHelper.dragDelegate(function (e, delta) {
      console.log('drag');
      self.setState({
        progress: Math.max(0, Math.min(delta.x / unit + progress, 100))
      });
      e.stopPropagation();
      e.preventDefault();
    }, function (e) {
      e.stopPropagation();
      e.preventDefault();
    });
    e.stopPropagation();
    e.preventDefault();
  },
  onTrackClick: function (e) {
    var parent = ReactDOM.findDOMNode(this.refs.slider);
    var parentRects = parent.getBoundingClientRect();
    var offsetLeft = e.clientX - parentRects.left;
    var width = parseInt(this.props.w, 10);
    this.setState({
      progress: offsetLeft / width * 100
    });
  }

});

module.exports = Slider;



// WEBPACK FOOTER //
// ./src/views/Components/Slider.jsx